var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IntroHeaderMobile'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path,staticClass:"layoutSubMain"})],1),_c('IntroNavbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }